class FacetFiltersForm extends HTMLElement {
  
  static get observedAttributes() {
    return ['selected-index'];
  }
  constructor() { 
    super();
    this.onActiveFilterClick = this.onActiveFilterClick.bind(this);
    this.debouncedOnSubmit = debounce((event) => {
       this.onSubmitHandler(event);
    }, 500);

    this.querySelector('form').addEventListener('input', this.debouncedOnSubmit.bind(this));
  }
  get selectedIndex() {
    return parseInt(this.getAttribute('selected-index')) || 0;
  }
  set selectedIndex(index) {
    this.setAttribute('selected-index', index);
  }
  static setListeners() {
    const onHistoryChange = (event) => {
      const searchParams = event.state ? event.state.searchParams : FacetFiltersForm.searchParamsInitial;
      if (searchParams === FacetFiltersForm.searchParamsPrev) return;
      FacetFiltersForm.renderPage(searchParams, null, false);
    };
    window.addEventListener('popstate', onHistoryChange);
  }

  static toggleActiveFacets(disable = true) {
    document.querySelectorAll('.js-facet-remove').forEach((element) => {
      element.classList.toggle('disabled', disable);
    });
  }

  static toggleActiveTabs() { 
    //alert(2);
    if($(window).width() > 768){
    document.querySelectorAll('.facets-popup-modal--tabs-button').forEach((element, i) => {
      element.classList.toggle('active', i == FacetFiltersForm.selectedIndex);
    });
    document.querySelectorAll('.facets-popup-modal--tab').forEach((element, i) => {
      element.classList.toggle('active', i == FacetFiltersForm.selectedIndex);
    });
    }
  }

  static renderPage(searchParams, event, updateURLHash = true) {
    FacetFiltersForm.searchParamsPrev = searchParams;
    const sections = FacetFiltersForm.getSections();
    const container = document.getElementsByClassName('thb-filter-count');
    document.getElementById('ProductGridContainer').querySelector('.collection').classList.add('loading');

    for (var item of container) {
      item.classList.add('loading');
    }

    sections.forEach((section) => {
      const url = `${window.location.pathname}?section_id=${section.section}&${searchParams}`;
      const filterDataUrl = element => element.url === url;

      if (FacetFiltersForm.filterData.some(filterDataUrl)) {
        FacetFiltersForm.renderSectionFromCache(filterDataUrl, event);
      } else {
        FacetFiltersForm.renderSectionFromFetch(url, event);
      }
    });
    if (updateURLHash) FacetFiltersForm.updateURLHash(searchParams);
  }

  static renderSectionFromFetch(url, event) {
    var data_index = $('.filter_tab.active_tab').parents('.facets-popup-modal--tab').attr('data-index');
    var data_type = $('button.facets-popup-modal--tabs-button.active').attr('data-type');
    fetch(url)
      .then(response => response.text())
      .then((responseText) => {
        const html = responseText;
        FacetFiltersForm.filterData = [...FacetFiltersForm.filterData, {
          html,
          url
        }];
        FacetFiltersForm.renderFilters(html, event);
        FacetFiltersForm.renderProductGridContainer(html,data_index,data_type);
        FacetFiltersForm.renderProductCount(html);

      });
  }

  static renderSectionFromCache(filterDataUrl, event) {
      var data_index = $('.filter_tab.active_tab').parents('.facets-popup-modal--tab').attr('data-index');
      var data_type = $('button.facets-popup-modal--tabs-button.active').attr('data-type');
    const html = FacetFiltersForm.filterData.find(filterDataUrl).html;
    FacetFiltersForm.renderFilters(html, event);
    FacetFiltersForm.renderProductGridContainer(html,data_index,data_type);
    FacetFiltersForm.renderProductCount(html);
  }

  static renderProductGridContainer(html,data_index,data_type) {
    document.getElementById('ProductGridContainer').innerHTML = new DOMParser().parseFromString(html, 'text/html').getElementById('ProductGridContainer').innerHTML;
    if($(window).width() > 767 ){
    $('.filter_sub_list').hide();
    $('.facets-popup-modal--tab').removeClass('active');
    $('.facets-popup-modal--tab[data-index="'+data_index+'"]').addClass('active');
    $('.facets-popup-modal--tab[data-index="'+data_index+'"] .filter_tab').addClass('active_tab');
   $('.facets-popup-modal--tab[data-index="'+data_index+'"] .filter_sub_list').show();
    }
    else{
      
      $('.facets-popup-modal--tabs-button').removeClass('active');
      $('.facets-popup-modal--tabs-button[data-type="'+data_type+'"]').addClass('active');
      
    }
    ScrollTrigger.batch('.animations-true .product-card .product-featured-image-link, .animations-true .products .gallery--item figure', {
      start: "top 90%",
      onEnter: (elements, triggers) => {
        gsap.to(elements, { scale: 1, opacity: 1, stagger: 0.15, ease: window.theme.settings.animation_easing });
      }
    });
  }

  static renderProductCount(html) {
    const countHtml = new DOMParser().parseFromString(html, 'text/html').getElementById('ProductCount');
    const container = document.getElementsByClassName('thb-filter-count');

    if (countHtml) {
      for (var item of container) {
        item.innerHTML = countHtml.innerHTML;
        item.classList.remove('loading');
      }
    }

  }

  static renderFilters(html, event) {
    const parsedHTML = new DOMParser().parseFromString(html, 'text/html');

    const facetDetailsElements = parsedHTML.querySelectorAll('#FacetsModal-inner .facets-popup-modal--tab');
    const matchesIndex = (element) => {
      const jsFilter = event ? event.target.closest('.facets-popup-modal--tab') : undefined;
      return jsFilter ? element.dataset.index === jsFilter.dataset.index : false;
    };
    const facetsToRender = Array.from(facetDetailsElements).filter(element => !matchesIndex(element));

    facetsToRender.forEach((element) => {
      document.querySelector(`.facets-popup-modal--tab[data-index="${element.dataset.index}"]`).innerHTML = element.innerHTML;
    });

    FacetFiltersForm.renderTabs(parsedHTML);
    FacetFiltersForm.renderActiveFacets(parsedHTML);
    FacetFiltersForm.renderAdditionalElements(parsedHTML);

    if (typeof SelectWidth !== 'undefined') {
      new SelectWidth();
    }
  }

  static renderTabs(html) {
    const tabsToRender = html.querySelector('#FacetsModal-inner .facets-popup-modal--tabs');
    const buttons = Array.from(html.querySelectorAll('.facets-popup-modal--tabs-button'));
    const index = FacetFiltersForm.selectedIndex;

    const tabSelectors = ['#FacetsModal-inner .facets-popup-modal--tabs, #FacetsModal-inner .facets-popup-modal__content-info'];

    tabSelectors.forEach((selector) => {
      const activeFacetsElement = html.querySelector(selector);
      if (!activeFacetsElement) return;
      document.querySelector(selector).innerHTML = activeFacetsElement.innerHTML;
    });

    FacetFiltersForm.toggleActiveTabs();
  }

  static renderActiveFacets(html) {
    const activeFacetElementSelectors = ['.active-facets'];

    activeFacetElementSelectors.forEach((selector) => {
      const activeFacetsElement = html.querySelector(selector);
      if (!activeFacetsElement) return;
      document.querySelector(selector).innerHTML = activeFacetsElement.innerHTML;
    });

    FacetFiltersForm.toggleActiveFacets(false);
  }

  static renderAdditionalElements(html) {
    const facetButtons = ['#Facets-Toggle', '#Facets-Toggle-Fixed', '#FacetFiltersForm-buttons', '.thb-filter-sort-count--bar', '.thb-filter-sort-count--modal'];

    facetButtons.forEach((selector) => {
      if (!html.querySelector(selector)) return;
      document.querySelector(selector).innerHTML = html.querySelector(selector).innerHTML;
    });
  }

  static updateURLHash(searchParams) {
    history.pushState({
      searchParams
    }, '', `${window.location.pathname}${searchParams && '?'.concat(searchParams)}`);
  }

  static getSections() {
    return [
      {
        section: document.getElementById('product-grid').dataset.id,
      }];
  }

  onSubmitHandler(event) {
    event.preventDefault();
    const formData = new FormData(event.target.closest('form'));
    const searchParams = new URLSearchParams(formData);


    if (searchParams.get('filter.v.price.gte') === "0.00") {
      searchParams.delete('filter.v.price.gte');
    }
    if (document.querySelector('.price_slider')) {
      if (searchParams.get('filter.v.price.lte') === parseFloat(document.querySelector('.price_slider').dataset.max).toFixed(2)) {
        searchParams.delete('filter.v.price.lte');
      }
    }
    FacetFiltersForm.renderPage(searchParams.toString(), event);
  }

  onActiveFilterClick(event) {
    event.preventDefault();
    FacetFiltersForm.toggleActiveFacets();
    const url = event.currentTarget.href.indexOf('?') == -1 ? '' : event.currentTarget.href.slice(event.currentTarget.href.indexOf('?') + 1);
    FacetFiltersForm.renderPage(url);
  }
}

FacetFiltersForm.filterData = [];
FacetFiltersForm.searchParamsInitial = window.location.search.slice(1);
FacetFiltersForm.searchParamsPrev = window.location.search.slice(1);
customElements.define('facet-filters-form', FacetFiltersForm);
FacetFiltersForm.setListeners();


class FacetRemove extends HTMLElement {
  constructor() {
    super();
    this.querySelectorAll('a').forEach((item) => {
      item.addEventListener('click', (event) => {
        event.preventDefault();
        const form = this.closest('facet-filters-form');
        form.onActiveFilterClick(event);
      });
    });
  }
}

customElements.define('facet-remove', FacetRemove);

/**
 *  @class
 *  @function PriceSlider
 */
class PriceSlider extends HTMLElement {

  constructor() {
    super();
  }
  connectedCallback() {
    let slider = this.querySelector('.price_slider'),
      amounts = this.querySelector('.price_slider_amount'),
      args = {
        start: [parseFloat(slider.dataset.minValue || 0), parseFloat(slider.dataset.maxValue || slider.dataset.max)],
        connect: true,
        step: 10,
        direction: document.dir,
        range: {
          'min': 0,
          'max': parseFloat(slider.dataset.max)
        }
      },
      event = new CustomEvent('input'),
      form = this.closest('facet-filters-form') || document.querySelector('facet-filters-form');

    if (slider.classList.contains('noUi-target')) {
      slider.noUiSlider.destroy();
    }
    noUiSlider.create(slider, args);

    slider.noUiSlider.on('update', function (values) {
      amounts.querySelector('.field__input_min').value = values[0];
      amounts.querySelector('.field__input_max').value = values[1];
    });
    slider.noUiSlider.on('change', function (values) {
      form.querySelector('form').dispatchEvent(event);
    });
  }
}
customElements.define('price-slider', PriceSlider);


class Sortbynew extends HTMLElement {

  constructor() {
    super();
  }
  connectedCallback() {
     document.querySelectorAll('.facet-filters__sort-new li').forEach(function(item) {
     item.addEventListener('click', function(event) {
         event.preventDefault();
         var selected_val = this.getAttribute('value');
        document.querySelector('.selected-val span').textContent = this.textContent;
        $('.facet-filters__sort-new').addClass('hide').hide();
        var options = document.querySelectorAll('.facet-filters__sort option');
        options.forEach(function(option) {
            option.removeAttribute('selected');
        });
        $('.facet-filters__sort option[value="'+selected_val+'"]').attr('selected', 'selected');
         $('.facet-filters__sort').change();
       const formData = new FormData(event.target.closest('form'));
       const searchParams = new URLSearchParams(formData).toString();
        var url = window.location.href.indexOf('?') == -1 ? '' : window.location.href.slice(window.location.href.indexOf('?') + 1);
       //alert(url);
       var new_url ='';
       if(url == '' || url.indexOf('sort_by') == -1){
         url=searchParams;
       }else if(url.indexOf('sort_by') > -1){
         var url1 = new URL(`https://in.nooe.co/collections/${$('#collection-handle').val()}?${url}`);
      var search_params1 = url1.searchParams;
          search_params1.set('sort_by', selected_val);
         url1.search = search_params1.toString();
          new_url = url1.toString();
         url = new_url.split('?')[1];
       }
         
      history.pushState({url}, '', `${window.location.pathname}${url && '?'.concat(url)}`);
        FacetFiltersForm.renderPage(url, null, false);
       setTimeout(function(){ $('.facet-filters__sort-new').addClass('hide').hide();},500)
      });
      });
  }
}
customElements.define('facet-sortbynew', Sortbynew);

/**
 *  @class
 *  @function FacetsButtons
 */
if (!customElements.get('facet-buttons')) {
  class FacetButtons extends HTMLElement {
    constructor() {
      super();

    }
    connectedCallback() {
      this.setupObservers();

      this.debouncedOnDom = debounce((event) => {
        this.setupObservers();
      }, 500);

      this.addEventListener('DOMNodeInserted', this.debouncedOnDom.bind(this));
    }
    setupObservers() {
      this.buttons = this.querySelectorAll('button');
      this.drawer = document.getElementById(this.dataset.target);
      this.links = this.drawer.querySelectorAll('.facets-popup-modal--tabs-button');
      this.panels = this.drawer.querySelectorAll('.facets-popup-modal--tab');

      this.buttons.forEach((item, i) => {
        item.addEventListener('click', (e) => this.onClick(e, i));
      });
      // this.links.forEach((item, i) => {
      //   item.addEventListener('click', (e) => this.onClick(e, i));
      // });

     
    }
    onClick(e, i) {

      this.links.forEach((link) => {
        link.classList.remove('active');
      });
      this.links[i].classList.add('active');

      this.panels.forEach((panel) => {
        panel.classList.remove('active');
      });
      this.panels[i].classList.add('active');

      FacetFiltersForm.selectedIndex = i;
      e.preventDefault();
    }
  }

  customElements.define('facet-buttons', FacetButtons);
}

/**
 *  @class
 *  @function FacetToggle
 */
if (!customElements.get('facet-toggle')) {
  class FacetToggle extends HTMLElement {
    constructor() {
      super();
    }
    connectedCallback() {
      this.drawer = document.getElementById(this.dataset.target);
      this.wrapper = this.closest('.collection-container').querySelector('#product-grid');
      this.form = this.closest('#FacetFiltersForm');
      this.addEventListener('click', this.onClick.bind(this));

      this.setupObservers();
    }
    disconnectedCallback() {
      this.observer.unobserve(this.wrapper);
    }
    setupObservers() {
      window.addEventListener('scroll', this.onScroll.bind(this));
    }
    onClick() {
      this.drawer.show();
      if($('.facets-popup-modal--tab.active').length == 0){
        $('.facets-popup-modal--tab:first-child').addClass('active');
      }
    }
    onScroll() {
      var container = $('#product-grid')
      let total = container.offset().top + container.outerHeight() - window.innerHeight + 90;
      let wrapper_offsetHeight = container.offset().top-500;
      if (window.scrollY < wrapper_offsetHeight) {
        this.classList.remove('sticky');
      } else if (window.scrollY > wrapper_offsetHeight && window.scrollY < total) {
        this.classList.add('sticky');
      } else if (window.scrollY >= total) {
        this.classList.remove('sticky');
      }
    }
  }

  customElements.define('facet-toggle', FacetToggle);
}
 $(document).on('click','.facets-popup-modal--tabs-button',function(e){
         e.preventDefault();
        $('.facets-popup-modal--tabs-button').removeClass('active');
        $(this).addClass('active');
        var type= $(this).attr('data-type');
        $('.facets-popup-modal--tab').removeClass('active');
        $('.facets-popup-modal--tab[data-type="'+type+'"]').addClass('active');
      })